'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PerspectiveY = function (_React$Component) {
	(0, _inherits3.default)(PerspectiveY, _React$Component);

	function PerspectiveY() {
		(0, _classCallCheck3.default)(this, PerspectiveY);
		return (0, _possibleConstructorReturn3.default)(this, (PerspectiveY.__proto__ || Object.getPrototypeOf(PerspectiveY)).apply(this, arguments));
	}

	(0, _createClass3.default)(PerspectiveY, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    width = _props.width,
			    lineHeight = _props.lineHeight,
			    lineSpacing = _props.lineSpacing;

			var offset = lineHeight + lineSpacing;
			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerPerspectiveY' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '2620467554',
					css: '.BurgerPerspectiveY .BurgerBox{-webkit-perspective:' + width * 2 + 'px;-moz-perspective:' + width * 2 + 'px;-ms-perspective:' + width * 2 + 'px;perspective:' + width * 2 + 'px;}.BurgerPerspectiveY .BurgerInner{-webkit-transition:-webkit-transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);-webkit-transition:transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);transition:transform 0.15s cubic-bezier(0.645,0.045,0.355,1), background-color 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);}.BurgerPerspectiveY .BurgerInner:before,.BurgerPerspectiveY .BurgerInner:after{-webkit-transition:-webkit-transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);-webkit-transition:transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);transition:transform 0s 0.1s cubic-bezier(0.645,0.045,0.355,1);}.BurgerPerspectiveY.BurgerActive .BurgerInner{background-color:transparent;-webkit-transform:rotateX(-180deg);-ms-transform:rotateX(-180deg);transform:rotateX(-180deg);}.BurgerPerspectiveY.BurgerActive .BurgerInner:before{-webkit-transform:translate3d(0,' + offset + 'px,0) rotate(45deg);-ms-transform:translate3d(0,' + offset + 'px,0) rotate(45deg);transform:translate3d(0,' + offset + 'px,0) rotate(45deg);}.BurgerPerspectiveY.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);-ms-transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);transform:translate3d(0,' + offset * -1 + 'px,0) rotate(-45deg);}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/perspective-y.js */',
					dynamic: [width * 2, offset, offset * -1]
				})
			);
		}
	}]);
	return PerspectiveY;
}(_react2.default.Component);

exports.default = PerspectiveY;


PerspectiveY.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=perspective-y.js.map